// GENERATED FILE -- do not edit by hand.
// Regenerate with `npm run codegen:stores` (see frontend/package.json).
// Source: agent.shared.types.repository.ConflictRegion

import { makeObservable, observable } from "mobx";
import { applyJsonPatch, JsonPatchOp } from "@/app_store/rpc/json_patch";
import { AgentTransport, callRpc } from "@/app_store/rpc/rpc";
import { registerEntity, wrapEntity } from "@/app_store/rpc/entity";

export interface ConflictRegionData {
    // Stamped onto every @observable model's dump at runtime (see
    // common._ObservableMixin._serialize_with_tag) -- tells wrapEntity which
    // generated Store class this value belongs to. Never sent by a client.
    _entity_class_name: "ConflictRegion";
    start: number;
    base: number;
    sep: number;
    end: number;
}

export class ConflictRegionStore {
    readonly _entity_class_name = "ConflictRegion" as const;
    start: number;
    base: number;
    sep: number;
    end: number;
    private _transport: AgentTransport;
    private _chainPath: string[];

    constructor(data: ConflictRegionData, transport: AgentTransport, chainPath: string[] = []) {
        this._transport = transport;
        this._chainPath = chainPath;
        this.start = wrapEntity(data.start, transport, [...chainPath, "start"]);
        this.base = wrapEntity(data.base, transport, [...chainPath, "base"]);
        this.sep = wrapEntity(data.sep, transport, [...chainPath, "sep"]);
        this.end = wrapEntity(data.end, transport, [...chainPath, "end"]);
        makeObservable(this, {
            start: observable,
            base: observable,
            sep: observable,
            end: observable,
        });
    }

    applyPatch(op: JsonPatchOp): void {
        applyJsonPatch(this, op);
    }
}

registerEntity("ConflictRegion", ConflictRegionStore);
